import { Card, debounce, useTheme } from '@mui/material';
import { SidebarHeader } from '../sidebarHeader';
import { SidebarAccordionSection } from '../sidebarAccordionSection';
import { SIDEBAR_COMPONENTS_CONTENT } from '../../config';
import { EditorMode } from '../../types';
import { useState } from 'react';
import { useResponsive } from 'src/hooks/useResponsive';

type Props = {
  mode: EditorMode;
};

export const SidebarComponents = ({ mode }: Props) => {
  const theme = useTheme();
  const isMobile = useResponsive('down', 'md');
  const isClosed = isMobile || mode === 'preview';
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = debounce((value: string) => {
    setSearchTerm(value);
  }, 10);

  const filteredContent = SIDEBAR_COMPONENTS_CONTENT.map((group) => ({
    ...group,
    elements: group.elements.filter((element) =>
      element.name.toLowerCase().includes(searchTerm.toLowerCase())
    ),
  })).filter((group) => group.elements.length > 0);

  return (
    <Card
      sx={{
        flexShrink: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        height: '750px',
        width: isClosed ? 0 : '350px',
        borderRight: isClosed ? 'none' : `1px solid ${theme.palette.grey[300]}`,
        overflowY: 'scroll',
        transition: 'width 0.3s ease, border-right 0.3s ease',
      }}
    >
      <SidebarHeader searchTerm={searchTerm} handleSearch={handleSearch} />
      {filteredContent?.map((group) => (
        <SidebarAccordionSection
          title={group.groupTitle}
          key={group.groupTitle}
          elements={group.elements}
        />
      ))}
    </Card>
  );
};
